import React from 'react';
import ReactMarkdown from 'react-markdown';
import { TEACHER_FOCUS } from '../../constants/navigation';
import { TeacherFocus as TeacherFocusInterface } from '../../types';
import { StyledTeacherFocus } from '../Styled';

interface IFocus {
  page: string;
  focuses?: Array<TeacherFocusInterface>;
}

export const TeacherFocus = (props: IFocus): JSX.Element => {
  const { focuses, page } = props;
  const currentFocus = focuses?.find(focus => focus.screen == TEACHER_FOCUS[page]);
  let content = currentFocus?.content || focuses?.slice(0, 1).shift()?.content;
  content = content === undefined ? '' : content.replace(/\n/g, '\n\n');

  return (
    <StyledTeacherFocus>
      <ReactMarkdown skipHtml={false}>{content}</ReactMarkdown>
    </StyledTeacherFocus>
  );
};
